export default __webpack_public_path__ + "static/media/student_basic.e1006a7e.png";